import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
export var styles = function styles(_ref) {
  var spacing = _ref.spacing;
  return {
    root: {
      padding: spacing(3)
    }
  };
}; // eslint-disable-next-line prefer-arrow-callback

export var ModalContent = React.forwardRef(function ModalContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      children = props.children,
      rest = _objectWithoutProperties(props, ["classes", "className", "children"]);

  return React.createElement("div", _extends({
    className: classNames(classes.root, className),
    ref: ref
  }, rest), children);
});
process.env.NODE_ENV !== "production" ? ModalContent.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  className: PropTypes.string
} : void 0;
ModalContent.defaultProps = {
  className: null,
  children: null
};
export default withStyles(styles, {
  name: 'ModalContent'
})(ModalContent);